export default "__VITE_ASSET__DTZJTv6i__"